export default __webpack_public_path__ + "static/media/gate2.fa42ee75.png";